import React, { useEffect, useRef, useState } from 'react';
import {Grid, Hidden, Slider} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PlayPauseButton from '../components/PlayPauseButton';
import Backward from './Backward';
import Forward from './Forward';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import clsx from 'clsx';
import IconButton from '@material-ui/core/IconButton';
import Rating from '@material-ui/lab/Rating';

const useStyles = makeStyles((theme) => ({
  container: {
    fontFamily: 'Arial',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(3)
    }
  },
  playSlider: {
    width: 180
  },
  playSliderRail: {
    height: 2,
    background: theme.palette.iconColor
  },
  playSliderTrack: {
    height: 2,
    background: 'red'
  },
  playSliderThumb: {
    display: 'none'
  },
  forward: {
    color: theme.palette.iconColor
  },
  playbackRate: {
    width: 25,
    cursor: 'pointer',
    color: theme.palette.iconColor
  },
  startPoint: {
    width: 60,
    paddingRight: 10,
    textAlign: 'right',
    color: theme.palette.iconColor
  },
  endPoint: {
    width: 60,
    paddingLeft: 10,
    textAlign: 'left',
    cursor: 'pointer',
    color: theme.palette.iconColor
  },
  volumeSlider: {
    width: 40,
    minWidth: 40,
    marginTop: 3
    /*'&:hover $sliderItem': {
            opacity: 1,
            display: 'block',
        },
        '&:hover $volumeIcon': {
            opacity: 0,
            display: 'none',
        },*/
  },
  volumeIcon: {
    color: 'white',
    cursor: 'pointer',
    position: 'absolute',
    marginTop: 50,
    marginLeft: -10,
  },
  sliderItem: {
    height: 60,
    marginTop: 15,
    position: 'absolute',
    // opacity: 0,
    // display: 'none',
  },
  volSliderRail: {
    height: 2,
    background: '#858484'
  },
  volSliderTrack: {
    height: 2,
    background: '#FFF'
  },
  volSliderThumb: {
    background: '#C4C4C4'
  },
  container1: {
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(3),
      marginTop: 0
    }
  },
  currentTime: {
    color: '#fff',
    fontFamily: 'Arial',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14
    }
  },
  buttonIcon: {
    padding: 0
  }
}));

export const Timer = (props) => {
  const classes = useStyles();
  const { currentTime } = props;

  return <div className={classes.currentTime}>{currentTime}</div>;
};

export const PlaybackRate = (props) => {
  const classes = useStyles();
  const { playbackRate, changePlaybackRate } = props;

  return (
    <span className={classes.playbackRate} onClick={changePlaybackRate}>
      {playbackRate}
    </span>
  );
};

export const PlaySlider = (props) => {
  const classes = useStyles();

  const [value, setValue] = React.useState(0);

  useEffect(() => {
    if (props.currentTimeMSS) {
      setValue(props.currentTimeMSS);
    }
  }, [props.currentTimeMSS]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.handlePlayerProgress(newValue);
  };

  return (
    <Grid
      container
      spacing={1}
      className={classes.playSlider}
      justify="center"
      alignItems="center"
    >
      <Slider
        classes={{
          rail: classes.playSliderRail,
          track: classes.playSliderTrack,
          thumb: classes.playSliderThumb
        }}
        min={0}
        max={props.duration}
        orientation="horizontal"
        value={value}
        onChange={handleChange}
        aria-labelledby="play-slider"
      />
    </Grid>
  );
};

export const VolumeSlider = (props) => {
  const classes = useStyles();
  const { stateVolume, handleVolume } = props;
  const [isMute, setIsMute] = useState(false);
  const handleMute = (event) => {
    setIsMute(true);
    props.handleMute(isMute);
  };
  const handleMuteOff = (event) => {
    setIsMute(false);
    props.handleMute(isMute);
  };
  const handleVolumeChange = (event, newValue) => {
    handleVolume(event, newValue);
    setIsMute(false);
  };

  return (
    <Grid
      container
      spacing={1}
      className={clsx('volumeSlider', classes.volumeSlider)}
      justify="center"
      alignItems="center"
    >
      <Grid item xs className={clsx('sliderItem', classes.sliderItem)}>
        <Slider
          classes={{
            rail: classes.volSliderRail,
            track: classes.volSliderTrack,
            thumb: classes.volSliderThumb
          }}
          orientation="vertical"
          value={Math.round(stateVolume * 100)}
          onChange={handleVolumeChange}
          aria-labelledby="volume-slider"
        />
      </Grid>
      <Grid item>
        {isMute ? (
          <VolumeOffIcon
            className={clsx('volumeIcon', classes.volumeIcon)}
            onClick={handleMuteOff}
          />
        ) : (
          <VolumeUpIcon
            className={clsx('volumeIcon', classes.volumeIcon)}
            onClick={handleMute}
          />
        )}
      </Grid>
    </Grid>
  );
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export const RatingCard = (props) => {
  const classes = useStyles();
  const { onRatingHandle } = props;
  const [value, setValue] = React.useState(3);
  const prevFiveStar = usePrevious(props.isFiveStar);
  useEffect(() => {
    if (prevFiveStar !== props.isFiveStar) {
      setValue(props.isFiveStar);
    }
  }, [props.isFiveStar]);

  const ratingHandler = (newValue) => {
    setValue(newValue);
    if (newValue === 5) {
      onRatingHandle(props.stationid);
    }
  };

  return (
    <Grid item>
      <Rating
        classes={{
          iconEmpty: classes.starEmpty
        }}
        name="simple-controlled"
        value={value}
        onChange={(event, newValue) => {
          ratingHandler(newValue);
        }}
      />
    </Grid>
  );
};

const Controls = (props) => {
  const classes = useStyles();
  const { main, mini, expanded } = props;

  const [remainTime, setRemainTime] = useState(false);
  const switchRemainingTime = () => {
    setRemainTime(!remainTime);
  };

  const handleForward = () => {
    props.handleForward(props.duration);
  };

  const mainPlayer = () => {
    return (
      <Grid container justify="center" alignItems="center">
        <Grid container direction="column" className={classes.container}>
          <Grid item>
            <Grid
              container
              direction="row"
              justify="space-evenly"
              alignItems="center"
              className={classes.playPauseIcon}
            >
              <PlaybackRate
                playbackRate={props.playbackRate}
                changePlaybackRate={props.changePlaybackRate}
              />
              <IconButton
                className={classes.buttonIcon}
                onClick={props.handleBackward}
              >
                <Backward />
              </IconButton>
              <PlayPauseButton
                main={main}
                expanded={expanded}
                player={props.player}
                toggleAudio={props.toggleAudio}
                status={props.audioStatus}
              />
              <IconButton
                className={classes.buttonIcon}
                onClick={handleForward}
              >
                <Forward />
              </IconButton>
            </Grid>
            <Grid item style={{ display: 'flex' }}>
              <span className={classes.startPoint}>
                <Timer currentTime={props.currentTime} />
              </span>
              <PlaySlider
                currentTimeMSS={props.currentTimeMSS}
                duration={props.duration}
                handlePlayerProgress={props.handlePlayerProgress}
              />
              <span className={classes.endPoint} onClick={switchRemainingTime}>
                {remainTime ? (
                  <Timer currentTime={props.remainingTime} />
                ) : (
                  <Timer currentTime={props.totalLength} />
                )}
              </span>
            </Grid>
          </Grid>
          <Hidden mdDown>
            <Grid item>
              <VolumeSlider
                  stateVolume={props.stateVolume}
                  handleVolume={props.handleVolume}
                  handleMute={props.handleMute}
              />
            </Grid>
          </Hidden>
        </Grid>
      </Grid>
    );
  };

  const miniPlayer = () => {
    return (
      <Grid
        container
        direction={expanded ? 'column' : 'row'}
        justify="center"
        alignItems="center"
      >
        {expanded ? (
          <>
            <Grid item>
              <Grid
                container
                direction="row"
                justify="space-evenly"
                alignItems="center"
                className={classes.playPauseIcon}
              >
                <PlaybackRate
                  playbackRate={props.playbackRate}
                  changePlaybackRate={props.changePlaybackRate}
                />
                <IconButton
                  className={classes.buttonIcon}
                  onClick={props.handleBackward}
                >
                  <Backward />
                </IconButton>
                <PlayPauseButton
                  main={main}
                  expanded={expanded}
                  player={props.player}
                  toggleAudio={props.toggleAudio}
                  status={props.audioStatus}
                />
                <IconButton
                  className={classes.buttonIcon}
                  onClick={handleForward}
                >
                  <Forward />
                </IconButton>
              </Grid>
              <Grid item style={{ display: 'flex' }}>
                <span className={classes.startPoint}>
                  <Timer currentTime={props.currentTime} />
                </span>
                <PlaySlider
                  currentTimeMSS={props.currentTimeMSS}
                  duration={props.duration}
                  handlePlayerProgress={props.handlePlayerProgress}
                />
                <span
                  className={classes.endPoint}
                  onClick={switchRemainingTime}
                >
                  {remainTime ? (
                    <Timer currentTime={props.remainingTime} />
                  ) : (
                    <Timer currentTime={props.totalLength} />
                  )}
                </span>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid item className={classes.container1}>
            <PlayPauseButton
              main={main}
              expanded={expanded}
              player={props.player}
              toggleAudio={props.toggleAudio}
              status={props.audioStatus}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <>
      {main && mainPlayer()}
      {mini && miniPlayer()}
    </>
  );
};

export default Controls;
